<template>
  <div>
    <section class="member-box">
      <div class="container">
        <div class="box">
          <h1>{{ $t("會員登入") }}</h1>
          <hr />
          <div class="form-group phone-box" style="position: relative">
            <label for="formGroupExampleInput">{{ $t("手機") }}</label>
            <div class="phone">
              <vue-tel-input @input="onInput" autocomplete="new-phone"></vue-tel-input>
            </div>
            <span id="showPhone" @click="viewphone = !viewphone"><img
                :src="viewphone ? 'img/eyes-n.png' : 'img/eyes-y.png'" style="width: auto; height: 16px" /></span>
          </div>
          <div class="form-group" style="position: relative">
            <label for="formGroupExampleInput">{{ $t("密碼") }}</label>
            <input :placeholder="$t('請輸入您的密碼')" :type="viewpassword ? 'text' : 'password'" class="form-control"
              v-model="password" autocomplete="new-password" maxlength="25" />
            <span id="showPw" @click="viewpassword = !viewpassword"><img
                :src="viewpassword ? 'img/eyes-n.png' : 'img/eyes-y.png'" style="width: auto; height: 16px" /></span>
          </div>
          <div class="form-group" style="margin-left: 90px" v-if="false">
            <div class="check-box">
              <input id="remember" type="checkbox" aria-label="Checkbox for following text input" v-model="remember" />
              <label for="remember">{{ $t("記住我(30天)") }}</label>
            </div>
          </div>
          <div class="form-group" style="position: relative" v-show="needVerify">
            <label for="formGroupExampleInput">{{ $t("驗證碼") }}</label>
            <input :placeholder="$t('請輸入驗證碼')" type="text" class="form-control" v-model="verifyCodeCheck"
              autocomplete="new-password" maxlength="5" />
          </div>
          <div class="form-group" style="
              justify-content: flex-end;
              margin-top: -15px;
              margin-bottom: 15px;
            " v-show="needVerify">
            <a href="javascript:void(0)" @click="refreshCode()"><img :src="validateImgSrc" width="140" height="40"
                style="cursor: pointer" /></a>
          </div>
          <div class="btn-box">
            <button class="form-btn" @click="handleLogin">{{ $t("登入") }}</button>
            <router-link :to="{ name: 'Register' }" tag="button" class="form-btn phone">{{ $t("手機號碼註冊") }}</router-link>
            <router-link :to="{ name: 'OldLogin' }" tag="button" class="form-btn old">{{ $t("舊會員登入")
            }}<P>{{ $t("僅限卡片會員") }}</P></router-link>
            <div class="circle-btn">
              <p>{{ $t("其他登入方式：") }}</p>
              <button @click="facebookLogin_App" v-if="isMobile" class="form-btn fb">
                <img src="img/fb_icon.svg" alt="" />
              </button>
              <button @click="lineLogin_App" v-if="isMobile" class="form-btn line">
                <img src="img/line_icon.svg" alt="" />
              </button>
              <button @click="googleLogin_App" v-if="isMobile" class="form-btn google">
                <img src="img/google_icon.svg" alt="" />
              </button>
              <button @click="facebookLogin" v-if="!isMobile" class="form-btn fb">
                <img src="img/fb_icon.svg" alt="" />
              </button>
              <button @click="lineLogin" v-if="!isMobile" class="form-btn line">
                <img src="img/line_icon.svg" alt="" />
              </button>
              <div v-if="!isMobile" style="margin: 0 10px">
                <GoogleLoginButton />
              </div>
            </div>
          </div>
          <!-- 0518 增加 連結 -->
          <router-link class="note" :to="{ name: 'Forget' }">{{
            $t("忘記密碼？")
          }}</router-link>
          <a class="note other-btn" href="javascript:void(0)" @click="gotoPostByPId(62)">{{ $t("服務條款")
          }}<span>》</span></a>
          <a class="note other-btn" href="javascript:void(0)" @click="gotoPostByPId(459)">{{ $t("隱私權聲明")
          }}<span>》</span></a>
          <router-link class="note other-btn" :to="{
            name: 'OtherList',
          }">{{ $t("其他資訊") }}<span>》</span></router-link>
          <div style="display: flex; text-align: end">
            <div style="width: 100%">Ver.{{ GLOBAL.localVer }}</div>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import GoogleLoginButton from "@/components/GoogleLoginButton.vue";

import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import { v4 as uuidv4 } from "uuid";
import Storage from "@/utils/storage.js";

Vue.use(VueTelInput, {
  autoDefaultCountry: true,
  defaultCountry: 886,
  dropdownOptions: {
    showDialCodeInSelection: true,
  },
  inputOptions: {
    placeholder: "",
  },
});
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    "會員登入": "會員登入",
    "手機": "手機",
    "密碼": "密碼",
    "請輸入您的密碼": "請輸入您的密碼",
    "記住我(30天)": "記住我(30天)",
    "登入": "登入",
    "手機號碼註冊": "手機號碼註冊",
    "舊會員登入": "舊會員登入",
    "僅限卡片會員": "僅限卡片會員",
    "忘記密碼？": "忘記密碼？",
    "其他資訊": "其他資訊",
    "錯誤": "錯誤",
    "手機號碼格式錯誤": "手機號碼格式錯誤",
    "確定": "確定",
    "登入成功": "登入成功",
    "手機號碼或密碼不可為空": "手機號碼或密碼不可為空",
    "其他登入方式：": "其他登入方式：",
    "請稍候...": "請稍候...",
    "請輸入正確的驗證碼": "請輸入正確的驗證碼",
  },
  en: {
    "會員登入": "Log in",
    "手機": "Mobile number",
    "密碼": "Password",
    "請輸入您的密碼": "Please enter your password",
    "記住我(30天)": "Remember me (30 days)",
    "登入": "Log in",
    "手機號碼註冊": "Phone Register",
    "舊會員登入": "Old member log in",
    "僅限卡片會員": "Card member only",
    "忘記密碼？": "Forgot the password?",
    "其他資訊": "Other info",
    "錯誤": "Error",
    "手機號碼格式錯誤": "Wrong mobile number format",
    "確定": "Confirm",
    "登入成功": "Logged in",
    "手機號碼或密碼不可為空": "The mobile number or password cannot be empty",
    "其他登入方式：": "Other Login Methods：",
    "請稍候...": "Please wait...",
    "請輸入正確的驗證碼": "Please enter the correct verification code",
  },
  jp: {
    "會員登入": "会員ログイン",
    "手機": "携帯電話",
    "密碼": "パスワード",
    "請輸入您的密碼": "パスワードを入力してください",
    "記住我(30天)": "覚えておいてください(30日)",
    "登入": "ログイン",
    "手機號碼註冊": "電話番号登録",
    "舊會員登入": "旧会員ログイン",
    "僅限卡片會員": "カード会員限定",
    "忘記密碼？": "パスワードをお忘れの方",
    "其他資訊": "その他の情報",
    "錯誤": "エラー",
    "手機號碼格式錯誤": "電話番号の形式が正しくありません",
    "確定": "確定",
    "登入成功": "ログインに成功しました",
    "手機號碼或密碼不可為空": "電話番号又はパスワードは必ず入力してください",
    "其他登入方式：": "その他のログイン方法：",
    "請稍候...": "お待ちください...",
    "請輸入正確的驗證碼": "正しい認証コードを入力してください",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "Login",
  components: {
    GoogleLoginButton,
  },
  i18n,
  data() {
    return {
      countryCallingCode: "",
      number: "",
      valid: false,
      password: "",
      remember: false,
      viewpassword: false,
      viewphone: false,
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null && typeof cordova != "undefined",
      appVersion: "",
      appVer: 0,
      needVerify: false,
      verifyCode: "",
      verifyCodeCheck: "",
      validateImgSrc: "",
      validateImgCode: "",
    };
  },
  watch: {
    verifyCodeCheck(newValue, oldValue) {
      var rules = new RegExp(/[^0-9]/g);
      if (rules.test(newValue)) {
        this.$nextTick(() => {
          this.verifyCodeCheck = newValue.replace(rules, '');
        })
      }
    },
    viewphone(newValue, oldValue) {
      if (newValue) {
        $(".vti__input").addClass("show_phone");
      } else {
        $(".vti__input").removeClass("show_phone");
      }
    },
  },
  created: function () {
    window.fbAsyncInit = function () {
      FB.init({
        appId: "145533181767491",
        xfbml: true,
        version: "v16.0",
      });
      FB.AppEvents.logPageView();
    };

    if (!window.FB) {
      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    }

    if (window.chcp) {
      let that = this;
      window.chcp.getVersionInfo((error, data) => {
        that.appVersion = data.appVersion;
        var ver = parseInt(data.appVersion.replaceAll(".", ""));
        that.appVer = ver;
        console.log(that.appVersion + ", " + that.appVer);
      });
    }
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套Class
    $(".wrapper").addClass("member-singin");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }

    if (Storage.isKey("ek_login_fail_times")) {
      this.needVerify = true;
      this.refreshCode();
    }

    // if (!this.isMobile) {
    //   window.google.accounts.id.initialize({
    //     client_id:
    //       "240420624722-7vn119ldtedd2b30dsll3ekaguouemm4.apps.googleusercontent.com",
    //     callback: this.googleLogin,
    //   });
    //   window.google.accounts.id.prompt();
    // }
  },
  updated: function () { },
  methods: {
    generateGUID() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return s4() + s4() + "-" + s4() + "-" + s4() + "-" +
        s4() + "-" + s4() + s4() + s4();
    },
    refreshCode() {
      this.validateImgCode = this.generateGUID();
      this.validateImgSrc = this.GLOBAL.apiSrc +
        this.GLOBAL.subDirectory + '/Htmlv2/CreateValidate?t=' + this.validateImgCode;
    },
    needUpdate: function () {
      Vue.swal({
        heightAuto: false,
        title: "需要更新APP",
        text:
          "您安裝的APP版本(" +
          this.appVersion +
          ")未支援此功能, 若要使用第三方登入, 請至APP商店下載最新版本, 造成不便敬請見諒!",
        icon: "info",
        allowOutsideClick: false,
        confirmButtonText: "立即前往",
        showCancelButton: true,
        cancelButtonText: "暫不更新",
      }).then((result) => {
        if (result.isConfirmed) {
          cordova.getAppVersion.getPackageName(function (pkgname) {
            if (device.platform == "iOS") {
              cordova.InAppBrowser.open(
                "itms-apps://itunes.apple.com/app/id1415685647",
                "_system"
              );
            } else {
              cordova.InAppBrowser.open(
                "market://details?id=" + pkgname,
                "_system"
              );
            }
          });
        }
      });
    },
    onInput(phone, phoneObject, input) {
      this.countryCallingCode = phoneObject.countryCallingCode;
      this.number = phoneObject.number;
      this.valid = phoneObject.valid;
    },
    handleLogin() {
      let that = this;
      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      if (!this.valid) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("手機號碼格式錯誤"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
      } else {
        let countryCallingCode =
          this.countryCallingCode == null ? "" : this.countryCallingCode;
        let number = this.number == null ? "" : this.number;
        let password = this.password;
        if (this.needVerify && !this.verifyCodeCheck) {
          this.$swal({
            heightAuto: false,
            title: this.$t("錯誤"),
            text: this.$t("請輸入正確的驗證碼"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
          });
          this.refreshCode();
          return;
        }
        // 帳號密碼需驗證不能為空
        if (countryCallingCode !== "" && number !== "" && password !== "") {
          let token = "";
          if (this.needVerify) {
            token = AES.encrypt(
              countryCallingCode +
              "|" +
              number +
              "|" +
              password +
              "|" +
              this.validateImgCode +
              "|" +
              this.verifyCodeCheck
            );
          } else {
            token = AES.encrypt(
              countryCallingCode + "|" + number + "|" + password
            );
          }
          $.ajax({
            url:
              that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Login",
            type: "post",
            data: {
              token: token
            },
            dataType: "json",
            error: function (jqXHR, textStatus, errorThrown) {
              var msg = "";
              if (jqXHR.status === 0) {
                msg = "0";
              } else if (jqXHR.status == 404) {
                msg = "404";
              } else if (jqXHR.status == 500) {
                msg = "500";
              } else if (textStatus === "parsererror") {
                msg = "-1001";
              } else if (textStatus === "timeout") {
                msg = "-1002";
              } else if (textStatus === "abort") {
                msg = "-1003";
              } else {
                msg = jqXHR.responseText;
              }
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: "連線過程發生錯誤(" + msg + "), 請稍後再試一次",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            },
            success: function (res) {
              // 判斷結果
              if (res.ok) {
                // 儲存登入Token
                // if (that.remember) {
                //   that.$cookies.set("ek_login_token", res.LoginToken, "30d");
                // } else {
                //   that.$cookies.set("ek_login_token", res.LoginToken, "1d");
                // }
                //that.$cookies.set("ek_login_token", res.LoginToken, "1y");
                Storage.remove("ek_login_fail_times");
                Storage.set("ek_login_token", res.LoginToken);
                that.$swal({
                  heightAuto: false,
                  icon: "success",
                  title: that.$t("登入成功"),
                  showConfirmButton: false,
                  timer: 1500,
                  willClose: function () {
                    // 轉到首頁
                    that.$router.push("/");
                  },
                  allowOutsideClick: false,
                });
              } else if (res.error_msg) {
                var error_msg = JSON.parse(res.error_msg);
                var tryTimes = 1;
                if (Storage.isKey("ek_login_fail_times")) {
                  tryTimes = parseInt(Storage.get("ek_login_fail_times"));
                  tryTimes += 1;
                }
                Storage.set("ek_login_fail_times", tryTimes);
                that.needVerify = true;
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
                that.refreshCode();
              }
            },
          });
        } else {
          this.$swal({
            heightAuto: false,
            title: this.$t("錯誤"),
            text: this.$t("手機號碼或密碼不可為空"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
          });
        }
      }
    },
    googleLogin_App() {
      if (this.appVer < 2018) {
        this.needUpdate();
        return;
      }
      let that = this;
      
      // 設置超時處理
      let loginTimeout;
      let isLoginComplete = false;
      
      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      
      // 設置30秒超時
      loginTimeout = setTimeout(function() {
        if (!isLoginComplete) {
          isLoginComplete = true;
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: "Google登入逾時，請檢查網路連線後再試一次",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        }
      }, 30000);
      
      window.plugins.googleplus.login(
        {
          offline: true,
        },
        function (res) {
          // 清除超時計時器
          if (loginTimeout) {
            clearTimeout(loginTimeout);
          }
          
          if (isLoginComplete) {
            return; // 如果已經超時，直接返回
          }
          
          // 檢查res是否有效
          if (!res || !res.userId) {
            isLoginComplete = true;
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: "Google登入資料無效，請重新嘗試",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
            return;
          }
          
          // 登入成功
          let token = AES.encrypt("Google|" + res.userId);
          $.ajax({
            url:
              that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Login",
            type: "post",
            data: {
              token: token,
              OAuthInfo: JSON.stringify(res),
            },
            dataType: "json",
            timeout: 15000, // 設置AJAX超時為15秒
            error: function (jqXHR, textStatus, errorThrown) {
              if (isLoginComplete) {
                return; // 如果已經處理過，直接返回
              }
              isLoginComplete = true;
              
              var msg = "";
              if (jqXHR.status === 0) {
                msg = "0";
              } else if (jqXHR.status == 404) {
                msg = "404";
              } else if (jqXHR.status == 500) {
                msg = "500";
              } else if (textStatus === "parsererror") {
                msg = "-1001";
              } else if (textStatus === "timeout") {
                msg = "-1002";
              } else if (textStatus === "abort") {
                msg = "-1003";
              } else {
                msg = jqXHR.responseText;
              }
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: "連線過程發生錯誤(" + msg + "), 請稍後再試一次",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            },
            success: function (res_login) {
              if (isLoginComplete) {
                return; // 如果已經處理過，直接返回
              }
              isLoginComplete = true;
              
              // 判斷結果
              if (res_login.ok) {
                Storage.set("ek_login_token", res_login.LoginToken, "1y");
                that.$swal({
                  heightAuto: false,
                  icon: "success",
                  title: that.$t("登入成功"),
                  showConfirmButton: false,
                  timer: 1500,
                  willClose: function () {
                    // 轉到首頁
                    that.$router.push("/");
                  },
                  allowOutsideClick: false,
                });
              } else if (res_login.error_msg) {
                var error_msg = JSON.parse(res_login.error_msg);
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text:
                    error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              } else {
                // 處理未知的成功狀態
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: "登入過程發生未知錯誤，請稍後再試一次",
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            },
          });
        },
        function (err) {
          // 清除超時計時器
          if (loginTimeout) {
            clearTimeout(loginTimeout);
          }
          
          if (isLoginComplete) {
            return; // 如果已經超時，直接返回
          }
          isLoginComplete = true;
          
          // 檢查是否為用戶取消操作
          if (err && typeof err === 'object' && err.error && err.error.toLowerCase().includes('cancel')) {
            that.$swal.close(); // 直接關閉載入對話框，不顯示錯誤
            return;
          }
          
          // 提供更詳細的錯誤信息
          let errorMessage = "登入過程發生錯誤, 請稍後再試一次";
          if (err) {
            errorMessage += " (錯誤詳情: " + JSON.stringify(err) + ")";
          }
          
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: errorMessage,
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        }
      );
    },
    facebookLogin_App() {
      if (this.appVer < 2018) {
        this.needUpdate();
        return;
      }
      let that = this;
      
      // 設置超時處理
      let loginTimeout;
      let isLoginComplete = false;
      
      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      
      // 設置30秒超時
      loginTimeout = setTimeout(function() {
        if (!isLoginComplete) {
          isLoginComplete = true;
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: "Facebook登入逾時，請檢查網路連線後再試一次",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        }
      }, 30000);
      
      facebookConnectPlugin.login(
        ["public_profile"],
        function (userData) {
          // 清除超時計時器
          if (loginTimeout) {
            clearTimeout(loginTimeout);
          }
          
          if (isLoginComplete) {
            return; // 如果已經超時，直接返回
          }
          
          // 檢查userData是否有效
          if (!userData || !userData.authResponse || !userData.authResponse.userID) {
            isLoginComplete = true;
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: "Facebook登入資料無效，請重新嘗試",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
            return;
          }
          
          // 登入成功
          let token = AES.encrypt("Facebook|" + userData.authResponse.userID);
          $.ajax({
            url:
              that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Login",
            type: "post",
            data: {
              token: token,
              OAuthInfo: JSON.stringify(userData),
            },
            dataType: "json",
            timeout: 15000, // 設置AJAX超時為15秒
            error: function (jqXHR, textStatus, errorThrown) {
              if (isLoginComplete) {
                return; // 如果已經處理過，直接返回
              }
              isLoginComplete = true;
              
              var msg = "";
              if (jqXHR.status === 0) {
                msg = "0";
              } else if (jqXHR.status == 404) {
                msg = "404";
              } else if (jqXHR.status == 500) {
                msg = "500";
              } else if (textStatus === "parsererror") {
                msg = "-1001";
              } else if (textStatus === "timeout") {
                msg = "-1002";
              } else if (textStatus === "abort") {
                msg = "-1003";
              } else {
                msg = jqXHR.responseText;
              }
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: "連線過程發生錯誤(" + msg + "), 請稍後再試一次",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            },
            success: function (res_login) {
              if (isLoginComplete) {
                return; // 如果已經處理過，直接返回
              }
              isLoginComplete = true;
              
              // 判斷結果
              if (res_login.ok) {
                Storage.set("ek_login_token", res_login.LoginToken, "1y");
                that.$swal({
                  heightAuto: false,
                  icon: "success",
                  title: that.$t("登入成功"),
                  showConfirmButton: false,
                  timer: 1500,
                  willClose: function () {
                    // 轉到首頁
                    that.$router.push("/");
                  },
                  allowOutsideClick: false,
                });
              } else if (res_login.error_msg) {
                var error_msg = JSON.parse(res_login.error_msg);
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text:
                    error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              } else {
                // 處理未知的成功狀態
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: "登入過程發生未知錯誤，請稍後再試一次",
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            },
          });
        },
        function loginError(error) {
          // 清除超時計時器
          if (loginTimeout) {
            clearTimeout(loginTimeout);
          }
          
          if (isLoginComplete) {
            return; // 如果已經超時，直接返回
          }
          isLoginComplete = true;
          
          // 檢查是否為用戶取消操作
          if (error && typeof error === 'string' && error.toLowerCase().includes('cancel')) {
            that.$swal.close(); // 直接關閉載入對話框，不顯示錯誤
            return;
          }
          
          // 提供更詳細的錯誤信息
          let errorMessage = "登入過程發生錯誤, 請稍後再試一次";
          if (error && typeof error === 'string') {
            errorMessage += " (錯誤詳情: " + error + ")";
          }
          
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: errorMessage,
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        },
        //{ apiVersion: "v22.0" }
      );
    },
    lineLogin_App() {
      if (this.appVer < 2018) {
        this.needUpdate();
        return;
      }
      let that = this;
      
      // 設置超時處理
      let loginTimeout;
      let isLoginComplete = false;
      
      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      
      // 設置30秒超時
      loginTimeout = setTimeout(function() {
        if (!isLoginComplete) {
          isLoginComplete = true;
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: "LINE登入逾時，請檢查網路連線後再試一次",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        }
      }, 30000);
      
      lineLogin.login(
        function (result) {
          // 清除超時計時器
          if (loginTimeout) {
            clearTimeout(loginTimeout);
          }
          
          if (isLoginComplete) {
            return; // 如果已經超時，直接返回
          }
          
          // 檢查result是否有效
          if (!result || !result.userID) {
            isLoginComplete = true;
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: "LINE登入資料無效，請重新嘗試",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
            return;
          }
          
          // 登入成功
          let token = AES.encrypt("LINE|" + result.userID);
          $.ajax({
            url:
              that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Login",
            type: "post",
            data: {
              token: token,
              OAuthInfo: JSON.stringify(result),
            },
            dataType: "json",
            timeout: 15000, // 設置AJAX超時為15秒
            error: function (jqXHR, textStatus, errorThrown) {
              if (isLoginComplete) {
                return; // 如果已經處理過，直接返回
              }
              isLoginComplete = true;
              
              var msg = "";
              if (jqXHR.status === 0) {
                msg = "0";
              } else if (jqXHR.status == 404) {
                msg = "404";
              } else if (jqXHR.status == 500) {
                msg = "500";
              } else if (textStatus === "parsererror") {
                msg = "-1001";
              } else if (textStatus === "timeout") {
                msg = "-1002";
              } else if (textStatus === "abort") {
                msg = "-1003";
              } else {
                msg = jqXHR.responseText;
              }
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: "連線過程發生錯誤(" + msg + "), 請稍後再試一次",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            },
            success: function (res) {
              if (isLoginComplete) {
                return; // 如果已經處理過，直接返回
              }
              isLoginComplete = true;
              
              // 判斷結果
              if (res.ok) {
                Storage.set("ek_login_token", res.LoginToken, "1y");
                that.$swal({
                  heightAuto: false,
                  icon: "success",
                  title: that.$t("登入成功"),
                  showConfirmButton: false,
                  timer: 1500,
                  willClose: function () {
                    // 轉到首頁
                    that.$router.push("/");
                  },
                  allowOutsideClick: false,
                });
              } else if (res.error_msg) {
                var error_msg = JSON.parse(res.error_msg);
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              } else {
                // 處理未知的成功狀態
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: "登入過程發生未知錯誤，請稍後再試一次",
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            },
          });
        },
        function (error) {
          // 清除超時計時器
          if (loginTimeout) {
            clearTimeout(loginTimeout);
          }
          
          if (isLoginComplete) {
            return; // 如果已經超時，直接返回
          }
          isLoginComplete = true;
          
          // 檢查是否為用戶取消操作
          if (error && typeof error === 'string' && error.toLowerCase().includes('cancel')) {
            that.$swal.close(); // 直接關閉載入對話框，不顯示錯誤
            return;
          }
          
          console.log("LINE Login Error: ", error);

          // 提供更詳細的錯誤信息
          let errorMessage = "登入過程發生錯誤, 請稍後再試一次";
          if (error && typeof error === 'string') {
            errorMessage += " (錯誤詳情: " + error + ")";
          }
          
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: errorMessage,
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        }
      );
    },
    googleLogin(response) {
      let that = this;
      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      $.ajax({
        url:
          that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/LoginGoogle",
        type: "post",
        data: {
          credential: response.credential,
        },
        dataType: "json",
        error: function (jqXHR, textStatus, errorThrown) {
          var msg = "";
          if (jqXHR.status === 0) {
            msg = "0";
          } else if (jqXHR.status == 404) {
            msg = "404";
          } else if (jqXHR.status == 500) {
            msg = "500";
          } else if (textStatus === "parsererror") {
            msg = "-1001";
          } else if (textStatus === "timeout") {
            msg = "-1002";
          } else if (textStatus === "abort") {
            msg = "-1003";
          } else {
            msg = jqXHR.responseText;
          }
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: "連線過程發生錯誤(" + msg + "), 請稍後再試一次",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            // 儲存登入Token
            // if (that.remember) {
            //   that.$cookies.set("ek_login_token", res.LoginToken, "30d");
            // } else {
            //   that.$cookies.set("ek_login_token", res.LoginToken, "1d");
            // }
            Storage.set("ek_login_token", res.LoginToken, "1y");
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("登入成功"),
              showConfirmButton: false,
              timer: 1500,
              willClose: function () {
                // 轉到首頁
                that.$router.push("/");
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
        // error: function () {},
        // success: function (res) {
        //   // 判斷結果
        //   if (res.ok) {
        //     that.$swal({
        //       title: that.$t("測試訊息"),
        //       text: res.data,
        //       allowOutsideClick: false,
        //       confirmButtonText: that.$t("確定"),
        //     });
        //   } else if (res.error) {
        //     that.$swal({
        //       title: that.$t("錯誤"),
        //       text: i18n.locale == "en" ? res.error_en : res.error,
        //       icon: "error",
        //       allowOutsideClick: false,
        //       confirmButtonText: that.$t("確定"),
        //     });
        //   }
        // },
      });
    },
    facebookLogin() {
      let that = this;
      // 顯示請稍候
      this.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      FB.login(
        function (response) {
          if (response.status === "connected") {
            $.ajax({
              url:
                that.GLOBAL.apiSrc +
                that.GLOBAL.subDirectory +
                "/Htmlv2/LoginFB",
              type: "post",
              data: {
                oAuthId: response.authResponse.userID,
                OAuthInfo: JSON.stringify(response),
              },
              dataType: "json",
              error: function (jqXHR, textStatus, errorThrown) {
                var msg = "";
                if (jqXHR.status === 0) {
                  msg = "0";
                } else if (jqXHR.status == 404) {
                  msg = "404";
                } else if (jqXHR.status == 500) {
                  msg = "500";
                } else if (textStatus === "parsererror") {
                  msg = "-1001";
                } else if (textStatus === "timeout") {
                  msg = "-1002";
                } else if (textStatus === "abort") {
                  msg = "-1003";
                } else {
                  msg = jqXHR.responseText;
                }
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: "連線過程發生錯誤(" + msg + "), 請稍後再試一次",
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              },
              success: function (res) {
                // 判斷結果
                if (res.ok) {
                  Storage.set("ek_login_token", res.LoginToken, "1y");
                  that.$swal({
                    heightAuto: false,
                    icon: "success",
                    title: that.$t("登入成功"),
                    showConfirmButton: false,
                    timer: 1500,
                    willClose: function () {
                      // 轉到首頁
                      that.$router.push("/");
                    },
                    allowOutsideClick: false,
                  });
                } else if (res.error_msg) {
                  var error_msg = JSON.parse(res.error_msg);
                  that.$swal({
                    heightAuto: false,
                    title: that.$t("錯誤"),
                    text: error_msg[i18n.locale],
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: that.$t("確定"),
                  });
                }
              },
            });
          } else {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: "登入過程發生錯誤, 請稍後再試一次",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
        // 授權 - 個人資料&Email
        { scope: "public_profile,email" }
      );
      // 檢查登入狀態
      // FB.getLoginStatus(function (response) {
      //   // 登入狀態 - 已登入
      //   if (response.status === "connected") {
      //     that.$swal({
      //       title: that.$t("測試訊息"),
      //       text: JSON.stringify(response),
      //       allowOutsideClick: false,
      //       confirmButtonText: that.$t("確定"),
      //     });
      //   } else {
      //     // 登入狀態 - 未登入
      //     // 用戶登入(確認授權)
      //     FB.login(
      //       function (res) {
      //         that.$swal({
      //           title: that.$t("測試訊息"),
      //           text: JSON.stringify(res),
      //           allowOutsideClick: false,
      //           confirmButtonText: that.$t("確定"),
      //         });
      //       },
      //       // 授權 - 個人資料&Email
      //       { scope: "public_profile,email" }
      //     );
      //   }
      // });
    },
    lineLogin() {
      let URL = "https://access.line.me/oauth2/v2.1/authorize?";
      URL += "response_type=code";
      URL += "&client_id=1660744776";
      URL +=
        "&redirect_uri=" +
        encodeURI(
          this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/LoginLine"
        );
      URL += "&state=" + uuidv4();
      URL += "&scope=profile";
      window.location.href = URL;
    },
    gotoPostByPId(PId) {
      this.$router.push({
        name: "Post",
        params: { PId: PId },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.member-box .form-group .phone {
  border: none;
}

.vue-tel-input {
  width: 100%;
}

#showPw {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
}

#showPhone {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue